// apiConfig.js
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const API_ENDPOINTS = {
    ewonStatus: `${API_BASE_URL}/api/ewonStatus`,
    VaccumTankLevels: `${API_BASE_URL}/api/VacTankLvls`,
    plcStatus: `${API_BASE_URL}/api/plcstatus`,
    signalStatus: `${API_BASE_URL}/api/signalStrength`,
    vacuumLevelbar: `${API_BASE_URL}/vacuumlevel`,
    tankLevelm: `${API_BASE_URL}/tanklevel`,
    alarmCount: `${API_BASE_URL}/api/totalrowcountVacuumAlarm`,
    openAlarm: `${API_BASE_URL}/api/OpenAlarmCount`,
    valveCount: `${API_BASE_URL}/api/ValveRowCount`,
    floatCount: `${API_BASE_URL}/api/FloatRowCount`,
    valveAlarmCount: `${API_BASE_URL}/api/ValveAlarmCount`,
    floatAlarmCount: `${API_BASE_URL}/api/FloatAlarmCount`,
    potAlarmCount: `${API_BASE_URL}/api/PotAlarmCount`,
    receivedOnTime: `${API_BASE_URL}/api/receivedON`,
    handlesearch: `${API_BASE_URL}/api/search`,
    selectvacuumalarm: `${API_BASE_URL}/api/VacuumAlarm`,
    AlarmPreLoad: `${API_BASE_URL}/api/AlarmPreLoad`,
    forgotpassword: `${API_BASE_URL}/api/ResetPasswordMail`,
    potAlarmshandlesearch: `${API_BASE_URL}/api/Potsearch`,
    selectpotdata: `${API_BASE_URL}/api/getpot`,
    potalarmpreload: `${API_BASE_URL}/api/PotAlarmPreLoad`,
    dailyvacuumlevel: `${API_BASE_URL}/api/dailyvacuumlevel`,
    dailyvacuumlevelTwo: `${API_BASE_URL}/api/dailyvacuumlevelTwo`,
    lastTwohourVacLvl: `${API_BASE_URL}/api/lasttwohoursvacuumlevel`,
    sensordevices: `${API_BASE_URL}/api/sensordevices`,
    sendTestSMS: `${API_BASE_URL}/api/sendTestSMS`,
    sendTestEmail: `${API_BASE_URL}/api/sendTestEmail`,
    AddUser: `${API_BASE_URL}/api/AddUser`,
    DeleteUser: `${API_BASE_URL}`,
    vshandlesearchone: `${API_BASE_URL}/api/vsanalyticsOne`,
    minmoaxvsanatcs: `${API_BASE_URL}/api/getminmaxalarmdata`,
    minmoaxvsanatcsTwo: `${API_BASE_URL}/api/getminmaxalarmdataTwo`,
    TotalPumpCyclesData: `${API_BASE_URL}/api/totalperdpumpcyc`,
    DetailedPumpCycles: `${API_BASE_URL}/api/detailedpumpcycles`,
    DetailedPumpCyclesDefaultReport: `${API_BASE_URL}/api/detailedpumpcyclesDefaultReport`,
    DevicePagePotClick: `${API_BASE_URL}/api/devicePagePotClick`,
    DetailedReportVP: `${API_BASE_URL}/api/detailedpumpcyclesVPS`,
    DpVPOptions: `${API_BASE_URL}/api/getpumptypes`,
    potAnalyticsData: `${API_BASE_URL}/api/fetchpotAnalyticsData`,
    perdaypotcycle: `${API_BASE_URL}/api/potcyclesday`,
    potclickdata: `${API_BASE_URL}/api/potclickdata`,
    DefaultReportPotclickdata: `${API_BASE_URL}/api/defaultgeneratepotclickdata`,
    DailyvacuumlevelFromSearch: `${API_BASE_URL}/api/dailyvacuumlevelSearch`,
    ProjectUsersGet: `${API_BASE_URL}`,
    StationBallonLocations: `${API_BASE_URL}/api/vacStationLocation`,
    PotBallonLocations: `${API_BASE_URL}/api/potLocation`,
    MasterDashboardProjectDetails: `${API_BASE_URL}/api/masterProjectDetails`,
    MasterLoginProjectsCredentials: `${API_BASE_URL}`,
    SendSignUpDetails: `${API_BASE_URL}/api/signUpSubmit`,
    SuperAdminLoginUserDetails: `${API_BASE_URL}/api/SuperAdminUserDetails`,
    SuperAdminSaveUserChanges: `${API_BASE_URL}/api/superAdminUserSettingsSaveChanges`,
    RemoteAcess: `${API_BASE_URL}/api/remote-access`,
    RemoteAccessPumpStatus: `${API_BASE_URL}/api/remote-access-PumpStatus`, 
    RemoteAccessPumpUpdate: `${API_BASE_URL}/api/remote-access-PumpUpdate`,
    GetRemoteLastActionStatus: `${API_BASE_URL}/api/getRemoteLastActionStatus`,
    GetRemotePumpModeStatus: `${API_BASE_URL}/api/remote-access-PumpModeStatus`,
    GetLoraNodeStatus: `${API_BASE_URL}/api/totalLoraStatusCount`,
    RemoteAccess_Reset_Only: `${API_BASE_URL}/api/remote-access-only-reset`,
    RemoteAccess_VacTankLvl_Reset_Only: `${API_BASE_URL}/api/remote-access-vactanklvls-reset-only`,
};
